import { DataAvailability } from './DataAvailability';

export enum WorkflowStatus {
  PENDING = 'pending',
  DOCUMENT_PROCESSING_COMPLETED = 'document_processing_completed',
  DOCUMENT_PROCESSING_COMPLETED_SCREENER = 'document_processing_completed_screener',
  DOCUMENT_PROCESSING_COMPLETED_DUEDILIGENCE = 'document_processing_completed_duediligence',
  SCREENER_STARTED = 'screener_started',
  SCREENER_COMPLETED = 'screener_completed',
  SCREENER_ERROR = 'screener_error',
  DUEDILLIGENCE_STARTED = 'duediligence_started',
  DUEDILLIGENCE_COMPLETED = 'duediligence_completed',
  DUEDILLIGENCE_ERROR = 'duediligence_error',
  ANALYSIS_STARTED = 'analysis_started',
  ANALYSIS_COMPLETED = 'analysis_completed',
  REPORT_STARTED = 'report_started',
  REPORT_COMPLETED = 'report_completed',
  ERROR = 'error',
  UNKNOWN = 'unknown',
  REPORT_ERROR = 'report_error',
}

export type Risks =
  | 'None'
  | {
      standard: string[];
      critical: string[];
    };

export type WorkflowState = {
  status: WorkflowStatus;
  updated_at: string;
  data_availability: DataAvailability;
  risks?: Risks;
};
